<template lang="html">
  <section class="http-error app-width">
    <h1>{{ error }}!</h1>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { metaPrerenderStatusCode } from '@/utils/meta';

export default {
  name: 'HttpError',

  metaInfo() {
    if (!this.httpError || !this.httpError.status) return;

    return {
      meta: [metaPrerenderStatusCode(this.httpError.status)],
    };
  },

  computed: {
    ...mapState(['httpError']),

    error() {
      if (this.httpError && this.httpError.status && this.httpError.title) {
        return `${this.httpError.status} ${this.httpError.title}`;
      }

      // We should only get here by reaching the catch-all route at the bottom
      // of the router config so it’s safe to call it a 404.
      return '404 Not Found';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/position-flex-center';

.http-error {
  @include position-flex-center;
}
</style>
